export default {
  "form.error.invalidEmail": {
    en: "Type a valid email (your.name@domain.com)",
    es: "Escribe un email válido (ejemplo@ejemplo.com).",
  },
  "form.error.tooLong": {
    en: "This text is too long, make it shorter.",
    es: "Ese texto es demasiado largo, acórtalo.",
  },
  "form.error.tooShort": {
    en: "This text must be at least __$1__ chars long.",
    es: "El texto debe tener al menos __$1__ caracteres.",
  },
  "form.error.required": {
    en: "To continue, fill this field.",
    es: "Para continuar, rellena este campo.",
  },
  "form.error.requiredSelect": {
    en: "To continue, select an option.",
    es: "Para continuar, elige una opción.",
  },
  "form.error.invalidCharacters": {
    en: 'Invalid characters entered. Please remove any \\ / * ? : " < > | % + #  characters.',
    es: 'Hay caracteres no permitidos. Por favor, elimina cualquier  / * ? : " < > | %',
  },
  "form.error.customFieldPattern": {
    en: 'Ensure the field name contains only lowercase letters and underscores. It should not begin with an underscore. For example, "my_custom_field".',
    es: "Asegúrate de que el nombre del campo contenga solo letras minúsculas y guiones bajos. No debe comenzar con un guión bajo. Por ejemplo, “mi_campo_personalizado”.",
  },
  "form.submit.saving": {
    en: "Saving...",
    es: "Guardando...",
  },
  "form.submit.save": {
    en: "Save",
    es: "Guardar",
  },
};
